<template>
  <div class="home-page">
    <HomeOpeningImage :mobileBanner="mobileBanner" v-if="isShowMobileBanner" />
    <HomeBannerKV :banners="banners" v-if="banners && banners.length > 0" />
    <SearchBar :cruiseFilters="cruiseFilters" id="SearchBar" />

<!--    <login-part v-if="!isLogin"></login-part>-->
    <HomeRecommendCruise v-if="cruiseCategories.length > 0 && promoCruiseItems.length > 0"
      :cruiseCategories="cruiseCategories"
      :promoCruiseItems="promoCruiseItems"
    />
    <HomeTopic
      v-if="promoBanners && promoBanners.length > 0"
      :promoBanners="promoBanners"
    />
    <RoyalShip :homeShip="homeShip" />
    <HomeDestination
      v-if="destinations && destinations.length > 0"
      :destinationRecommands="destinations"
    />
    <a class="global-airline" href="https://www.royalcaribbean.com/ultimate-world-cruise/">
      <img src="https://resource.rcclchina.com.cn/Home/turntable/globalAirline-MB-20260421.jpg" width="100%"/>
    </a>
    <HomeLikeRoute v-if="likeRoutePopupsList.length>1" :likeRoutePopupsList="likeRoutePopupsList" :cruiseCategories="cruiseCategories"
                   :isHomeShow="true"/>
    <HomeReview :reviewArticles="reviewArticles" />
    <HomeBottom />
    <HomeLastCruise
      :lastCruise="lastCruise"
      v-if="
        lastCruise && lastCruise.cruiseName && lastCruise.cruiseName.length > 0
      "
    />

    <EmergencyMessageAlert />

    <!-- <div class="wn-baby-left wn-baby-image" v-if="showPromo===0" id="wnBabyLeft" @click="goPromo">
      <img src="https://resource.rcclchina.com.cn/homePage/promotion/mb-2.gif"/>
    </div>
    <div class="wn-baby-right wn-baby-image" v-else-if="showPromo===1" id="wnBabyRight" @click="goPromo">
      <img src="https://resource.rcclchina.com.cn/homePage/promotion/mb-1.gif"/>
    </div> -->
  </div>
</template>

<script>
import api from "@/api";
import { getRandomInt } from '@/utilities/tools'
const promoCountDown = 8 * 1000;
const randomPromoOff = 1 * 1000;
const randomPromoShow = 6 * 1000 + randomPromoOff;

const HomeBannerKV = () => import("@/components/Home/HomeBannerKV");
const SearchBar = () => import("@/components/Home/SearchBar/SearchBar");
// const LoginPart = () => import("@/components/User/LoginPart");
const HomeRecommendCruise = () => import("@/components/Home/HomeRecommendCruise");
const HomeOpeningImage = () => import("@/components/Home/HomeOpeningImage");
const HomeTopic = () => import("@/components/Home/HomeTopic");
const RoyalShip = () => import("@/components/Home/RoyalShip");
const HomeDestination = () => import("@/components/Home/HomeDestination");
const HomeReview = () => import("@/components/Home/HomeReview");
const HomeBottom = () => import("@/components/Home/HomeBottom");
const HomeLastCruise = () => import("@/components/Home/HomeLastCruise");
const EmergencyMessageAlert = () => import("@/components/Home/EmergencyMessageAlert");
const HomeLikeRoute = ()=> import("@/components/Home/HomeLikeRoute")
const openingImageKey = "homeImageCookie";
import Cookies from "js-cookie";

export default {
  name: "Home",
  components: {
    HomeBannerKV,
    SearchBar,
    HomeRecommendCruise,
    HomeOpeningImage,
    HomeTopic,
    RoyalShip,
    HomeDestination,
    HomeReview,
    HomeBottom,
    HomeLastCruise,
    EmergencyMessageAlert,
    HomeLikeRoute
  },
  data() {
    return {
      lastCruise: {},
      isLogin: false,
      checkPromoTimeout: null,
      promoEffectInterval: null,
			showPromo: -1,
      likeRoutePopupsList:[]
    };
  },
  asyncData({ store }) {
    const userToken = store.state.user.userToken;
    return new Promise((resolve, reject) => {
      return store
        .dispatch("GET_HOME_PAGE", userToken)
        .then(() => {
          return store.dispatch("GET_CRUISE_FILTERS");
        })
        .then(() => {
          resolve();
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  mounted() {
    console.log( this.$store.state.page.homePage)
    const seo = {
      title: "全新海洋奇迹号 海洋光谱号-皇家加勒比国际游轮官方网站",
      description:
        "皇家加勒比国际游轮有限公司是全球著名游轮旅游服务公司,全球性豪华游轮品牌. 旗下豪华皇家船队包含: 海洋奇迹号、海洋光谱号、海洋量子号、海洋航行者号等豪华游轮",
      keyword:
        "皇家加勒比,皇家加勒比国际游轮官网,皇家加勒比国际游轮,豪华游轮旅游,豪华游轮,海洋奇迹号, 海洋光谱号, 奇迹号游轮 皇家奇迹号 光谱号游轮 皇家光谱号 奇迹号邮轮 光谱号邮轮",
    };
    this.$store.commit("SET_META", seo);

    this.changeHeaderTransparent();
    this.$store.commit("SET_PAGE_TITLE", "");
    window.addEventListener("scroll", this.changeHeaderTransparent);

    const userToken = this.$store.state.user.userToken
    this.isLogin = userToken && userToken.length > 0

    setTimeout(() => {
      this.getOneShoppingCart();
    }, 2000);
    this.changeHeaderTransparent();
    this.getGuessLikeList()
    // this.showPromoTimeout();
  },
  activated() {},
  beforeDestroy() {
    this.$store.commit("SET_HEADER_TRANS", false);
    window.removeEventListener("scroll", this.changeHeaderTransparent);
    this.showPromo = -1;
    if (this.checkPromoTimeout) {
			clearTimeout(this.checkPromoTimeout);
		}
    if (this.promoEffectInterval) {
      clearInterval(this.promoEffectInterval)
    }
  },
  methods: {
    async getOneShoppingCart() {
      const userToken = this.$store.state.user.userToken;
      if (!userToken || userToken.length == 0) {
        return;
      }
      const { data } = await api.booking.getOneShoppingCart({
        userName: userToken,
      });
      if (data && data.titleImage) {
        this.lastCruise = data;
        setTimeout(() => {
          this.lastCruise = {};
        }, 10000);
      }
    },
    async getGuessLikeList() {
      let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed'))
      let shipCode =  '';
      let sailDate =  '';
      if(recentlyViewed){
        shipCode = recentlyViewed.shipCode;
        sailDate = recentlyViewed.sailDate;
      }
      const { data ,success} = await api.booking.getGuessLikeList({
        shipCode:shipCode,
        sailDate:sailDate
      });
      if(success===true && data!==null){
        this.likeRoutePopupsList = data.cruises
      }
    },
    changeHeaderTransparent() {
      const needHeaderTrans = window.scrollY < 245;
      if (this.isHeaderTrans != needHeaderTrans) {
        this.$store.commit("SET_HEADER_TRANS", needHeaderTrans);
      }
    },
    showPromoTimeout () {
			if (this.checkPromoTimeout) {
				clearTimeout(this.checkPromoTimeout);
			}
			this.checkPromoTimeout = setTimeout(()=> {
				if (!this.userInfo || this.userInfo.userIdentity !== 1) {
					this.showPromoPopup();
				}
			}, promoCountDown)
		},
		showPromoPopup () {
			let random = Math.round(Math.random(100));
			this.showPromo = random % 2;
      if (this.showPromo === 0) {
        // 左边，位置出现在 10% ~ 70%
        let top = getRandomInt(10, 70);
				this.$nextTick(()=> {
					document.getElementById('wnBabyLeft').style.top = top + '%';
          this.showPromoEffect();
				})
      } else {
        // 右边，位置出现在 10% ~ 70%
				let top = getRandomInt(10, 70);
				this.$nextTick(()=> {
					document.getElementById('wnBabyRight').style.top = top + '%';
          this.showPromoEffect();
				})
      }

		},
    showPromoEffect () {
      if (this.promoEffectInterval) {
        clearInterval(this.promoEffectInterval)
      }
      this.promoEffectInterval = setInterval(()=> {
        if (this.showPromo === 0) {
          // 左边
          let initLeft = '-44px';
          let effectLeft = '-24px';
          document.getElementById('wnBabyLeft').style.left = effectLeft;
          setTimeout(()=> {
            // console.log(document.getElementById('wnBabyLeft'))
            document.getElementById('wnBabyLeft').style.left = initLeft;
          }, randomPromoOff);

        } else {
          // 右边

          let initRight = '-44px';
          let effectRight = '-24px';
          document.getElementById('wnBabyRight').style.right = effectRight;
          setTimeout(()=> {
            // console.log(document.getElementById('wnBabyRight'))
            document.getElementById('wnBabyRight').style.right = initRight;
          }, randomPromoOff);

        }

      }, randomPromoShow);
    },
    goPromo() {
      location.href = "https://mobile.rcclchina.com.cn/privilege/qibao"
    }
  },
  computed: {
    banners() {
      const homePage = this.$store.state.page.homePage;
      if (homePage && homePage.homeBanners) {
        return homePage.homeBanners.filter(function (banner) {
          return banner.type == 2;
        });
      }
      return [];
    },
    mobileBanner() {
      return this.$store.state.page.homePage.mobileBanner;
    },
    isShowMobileBanner() {
      var openingImage = Cookies.get(openingImageKey);
      if (openingImage && openingImage == "true") {
        return false;
      }
      if (!this.mobileBanner || !this.mobileBanner.id) {
        return false;
      }
      return true;
    },
    cruiseFilters() {
      return this.$store.state.cruise.cruiseFilters;
    },
    cruiseCategories() {
      const homePage = this.$store.state.page.homePage;
      if (
        homePage &&
        homePage.recommendCruiseArea &&
        homePage.recommendCruiseArea.promoCruiseCategories
      ) {
        return homePage.recommendCruiseArea.promoCruiseCategories.slice(0, 3);
      }
      return [];
    },
    promoCruiseItems() {
      const homePage = this.$store.state.page.homePage;
      if (
        homePage &&
        homePage.recommendCruiseArea &&
        homePage.recommendCruiseArea.cruisePromoItems
      ) {
        return homePage.recommendCruiseArea.cruisePromoItems;
      }
      return [];
    },
    promoBanners() {
      const homePage = this.$store.state.page.homePage;
      if (
        homePage &&
        homePage.recommendCruiseArea &&
        homePage.recommendCruiseArea.promoBanners
      ) {
        return homePage.recommendCruiseArea.promoBanners;
      }
      return [];
    },
    homeShip() {
      return this.$store.state.page.homePage.royalShip;
    },
    destinations() {
      return this.$store.state.page.homePage.recommendDestinations;
    },
    reviewArticles() {
      const homePage = this.$store.state.page.homePage;
      if (
        homePage &&
        homePage.recommendCruiseArea &&
        homePage.recommendCruiseArea.reviewArticles
      ) {
        return this.$store.state.page.homePage.recommendCruiseArea
          .reviewArticles;
      }
      return [];
    },
    isHeaderTrans() {
      return this.$store.state.page.isHeaderTrans || false;
    },
    userInfo () {
			return this.$store.state.user.userInfo
		}
  },
};
</script>

<style lang="less" scoped>
.wn-baby-image {
	position: fixed;
	width: 120px;

	z-index: 10;
	cursor: pointer;
	img {
		width: 100%;
	}
}
.wn-baby-left {
	left: -44px;
	top: 50%;
	transition: left 0.2s;
}

.wn-baby-right {
	right: -44px;
  bottom: 35px;
	transition: right 0.2s;
}
</style>

<style>
.widget-home-banner-widget {
  background: white;
}

.page-home .home-bar-nav {
  background-image: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.3) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
}
</style>

<style scoped>
.home-page {
  background-color: #fff;
  position: relative;
  top: -50px;
}

.announce-popup {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(30, 31, 34, 0.4);
  z-index: 99999;
  display: none;
}
.an-body {
  position: absolute;
  top: 95px;
  left: 50%;
  transform: translateX(-50%);
  width: 336px;
  border-radius: 15px;
  z-index: 999;
  padding-bottom: 20px;
  background: url("https://resource.rcclchina.com.cn/homePage/mobile/mb-gonggao.png")
    no-repeat center 100%;
  background-color: #fff;
}
.an-body > img.an-close {
  width: 40px;
  height: 40px;
  position: absolute;
  right: 0;
  top: -44px;
}
.an-body > img.tag {
  width: 49px;
  height: 49px;
  position: absolute;
  left: 50%;
  top: -2px;
  transform: translateX(-50%);
}
.an-title {
  width: 254px;
  font-size: 18px;
  font-weight: bold;
  color: #f73641;
  margin: 53px auto;
  text-align: center;
  line-height: 1.2;
  margin-bottom: 8px;
}
.an-content {
  width: 295px;
  margin: 0 auto;
  padding-top: 7px;
  border-top: 1px solid #dcdcdc;
}
.an-content .an-parah {
  color: #282b2c;
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 7px;
}
.an-content > img {
  width: 292px;
  height: 124px;
  border: 1.5px solid #ddbe6c;
  margin-bottom: 11px;
}
.an-content .an-btn {
  width: 100%;
  height: 45px;
  text-align: center;
  background-color: #ddbe6c;
  line-height: 45px;
  font-size: 15px;
  color: #282b2c;
}

.unfinished-route {
  width: 100%;
  position: fixed;
  height: 67px;
  bottom: 55px;
  padding: 0 10px;
  z-index: 22221;
}
.unfinishRoute-content .unfinishRoute-img,
.unfinishRoute-content .unfinishRoute-txt,
.unfinishRoute-content .unfinishRoute-downArrow {
  display: inline-block;
  vertical-align: middle;
}
.unfinishRoute-content .unfinishRoute-img img {
  width: 57px;
}
.unfinished-route .unfinishContent-route {
  width: 100%;
  height: 100%;
  position: relative;
}
.unfinishRoute-downArrow img {
  width: 30px;
}
.unfinished-route .unfinished-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  background: #000;
  opacity: 0.75;
  top: 0;
  z-index: 1;
  border-radius: 10px;
}
.unfinishContent-route .unfinishRoute-content {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 2;
  padding: 5px;
}
.unfinishRoute-content .unfinishRoute-txt {
  color: #fff;
  font-size: 12px;
}
.unfinishRoute-content .unfinishRoute-txt a {
  color: #fff;
}
.unfinishRoute-content .unfinishRoute-img {
  width: 57px;
  height: 57px;
  overflow: hidden;
}
.unfinishRoute-content .unfinishRoute-txt {
  width: 230px;
  height: 57px;
  overflow: hidden;
  padding: 0 5px;
}
.unfinishRoute-content .unfinishRoute-downArrow {
  width: 30px;
  height: 37px;
  overflow: hidden;
}
.global-airline img {
  display: block;
  width: 100%;
  margin-bottom: 15px;
}
</style>
